module.exports = __webpack_public_path__ + "static/media/hero-min.1cdd2a32.png";